// extracted by mini-css-extract-plugin
module.exports = {"reviewsWrapper":"hi","columnsWrapper":"hj","reviewsHeader":"hk","reviews":"hl"};